<div class="flex flex-col h-full">
  <div class="flex py-2 justify-end">
    <elcia-button (onClick)="showForm()" [icon]="'plus'" [label]="'action.add-user' | translate"/>
  </div>

  <div class="flex-1 overflow-hidden">
    <elcia-user-grid (onDelete)="deleteUser($event)" [currentUserId]="currentUserId()"
                     [isLoading]="isLoading()" [users]="users()"/>
  </div>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    [isActionLoading]="isSaving()"
    [mustDisplayDeleteButton]="false"
    [size]="'medium'"
    [title]="'entity.user' | translate">
    <elcia-user-form (onSubmit)="onFormSubmit($event)"/>
  </elcia-dialog>
}

<elcia-confirm-dialog/>
